import SiteMenu from "../components/menu";
import OpenGame from "../components/open-game";

export default function OpenGamePage() {
    return <>
        <SiteMenu />
        <OpenGame />
    </>
}
